import makeSlice from '@web/slices/purchaser/sliceMaker'

import {fetchSubscription} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchSubscription.fulfilled, (state, {payload: {subscriptionViewResult}}) => {
            const {naverMembership} = subscriptionViewResult

            // TODO:(정기구독 배송지) 26.02.05 purchaser 정보 추가가 dev환경에만 진행되어 alpha환경으로 api 요청시 purchaser 필드가 없음
            // alpha에 반영 이후 옵셔널체이닝 제거
            state.name = subscriptionViewResult.purchaser?.name ?? ''
            state.naverMembership = {
                currentEpisode: naverMembership.currentEpisode,
                membershipBenefitLayerExposed: naverMembership.membershipBenefitLayerExposed,
                membershipPlcc: naverMembership.membershipPlcc,
                subscribed: naverMembership.subscribed,
                shouldShowQuickJoinMembershipBanner: naverMembership.quickJoinMembershipBannerExposure,
            }
        })
    },
})

export default slice.reducer
